/**
 * Normalise a fund inception-date string to the canonical `MM/DD/YYYY`
 * slash format used across the corgifunds.com fund pages. Ported verbatim
 * from the dane etf-website `lib/format-inception.ts`.
 */
const MONTH_LOOKUP: Readonly<Record<string, number>> = {
  jan: 1,
  january: 1,
  feb: 2,
  february: 2,
  mar: 3,
  march: 3,
  apr: 4,
  april: 4,
  may: 5,
  jun: 6,
  june: 6,
  jul: 7,
  july: 7,
  aug: 8,
  august: 8,
  sep: 9,
  sept: 9,
  september: 9,
  oct: 10,
  october: 10,
  nov: 11,
  november: 11,
  dec: 12,
  december: 12,
};

function pad2(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

export function formatInceptionCanonical(dateStr: string | null | undefined): string {
  if (!dateStr) return "";
  const trimmed = dateStr.trim();

  const slashMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (slashMatch) {
    const m = Number.parseInt(slashMatch[1]!, 10);
    const d = Number.parseInt(slashMatch[2]!, 10);
    const y = slashMatch[3]!;
    if (m >= 1 && m <= 12 && d >= 1 && d <= 31) return `${pad2(m)}/${pad2(d)}/${y}`;
  }

  const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) {
    const y = isoMatch[1]!;
    const m = Number.parseInt(isoMatch[2]!, 10);
    const d = Number.parseInt(isoMatch[3]!, 10);
    if (m >= 1 && m <= 12 && d >= 1 && d <= 31) return `${pad2(m)}/${pad2(d)}/${y}`;
  }

  const naturalMatch = trimmed.match(/^([A-Za-z]+)\.?\s+(\d{1,2}),?\s+(\d{4})$/);
  if (naturalMatch) {
    const m = MONTH_LOOKUP[naturalMatch[1]!.toLowerCase()];
    const d = Number.parseInt(naturalMatch[2]!, 10);
    const y = naturalMatch[3]!;
    if (m && d >= 1 && d <= 31) return `${pad2(m)}/${pad2(d)}/${y}`;
  }

  return trimmed;
}
